export function isDefinedNotEmpty<T>(value: T | undefined | null): value is T {
  return (
    typeof value !== 'undefined' &&
    value !== null &&
    (typeof value !== 'string' || value.trim() !== '') &&
    (!Array.isArray(value) || value.length > 0) &&
    (typeof value !== 'object' || Object.keys(value).length > 0)
  );
}
